import { Mail, Globe, Apple, Smartphone } from "lucide-react";
import { Link } from "react-router-dom";
import { GOOGLE_PLAY_URL } from "@/lib/appLinks";

const cols = [
  {
    title: "Product",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Pricing", to: "/pricing" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact Us", to: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms & Conditions", to: "/terms" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Refund Policy", to: "/refund" },
      { label: "Photo & Content Policy", to: "/photo-content-policy" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1F4A2E] text-white pt-16 pb-6"
    >
      <div className="wrap grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1.2fr] gap-10">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/assets/brand/logo-header.png"
              alt="MyAdventure-Passport"
              width={48}
              height={50}
              className="w-12 h-[50px] object-contain"
            />
            <div className="leading-tight">
              <div className="font-extrabold tracking-[0.14em] text-sm">
                MYADVENTURE
              </div>
              <div className="text-[10px] tracking-[0.28em] font-bold text-[#FCD34D]">
                — PASSPORT —
              </div>
            </div>
          </div>
          <p className="mt-6 text-sm text-white/70 leading-relaxed max-w-xs">
            Camp · Stamp · Repeat. Collect every adventure — one stamp at a time.
          </p>
          <div className="mt-6 space-y-2 text-sm text-white/80">
            <div className="flex items-center gap-2 lg:whitespace-nowrap">
              <Mail className="w-4 h-4 text-[#FCD34D] shrink-0" />
              support@myadventure-passport.com
            </div>
            <div className="flex items-center gap-2 lg:whitespace-nowrap">
              <Globe className="w-4 h-4 text-[#FCD34D] shrink-0" />
              www.myadventure-passport.com
            </div>
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <div className="text-[12px] font-extrabold tracking-[0.18em] uppercase text-[#FCD34D] mb-5">
              {c.title}
            </div>
            <ul className="space-y-3">
              {c.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label
                      .toLowerCase()
                      .replace(/\s+/g, "-")}`}
                    className="text-sm text-white/80 hover:text-[#FCD34D] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div>
          <div className="text-[12px] font-extrabold tracking-[0.18em] uppercase text-[#FCD34D] mb-5">
            Get the App
          </div>
          <p className="text-sm text-white/80 mb-4">
            Live on Android &amp; iOS
          </p>
          <div className="flex flex-col gap-2">
            <a
              href={GOOGLE_PLAY_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta-android"
              className="btn bg-white text-[#1F4A2E] hover:bg-[#FCD34D] justify-center"
            >
              <Smartphone className="w-4 h-4" /> Get it on Google Play
            </a>
            <a
              href="https://apps.apple.com/my/app/myadventure-passport/id6803114683"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta-ios"
              className="btn justify-center"
              style={{
                background: "rgba(255,255,255,0.10)",
                color: "rgba(255,255,255,0.95)",
                border: "1px solid rgba(255,255,255,0.28)",
              }}
            >
              <Apple className="w-4 h-4" /> Download on the App Store
            </a>
          </div>
        </div>
      </div>

      <div className="wrap mt-12 pt-6 border-t border-white/15 text-[13px] text-white/60 flex flex-col sm:flex-row items-center justify-between gap-2">
        <span>© 2026 MyAdventure-Passport. All rights reserved.</span>
        <span className="text-white/50">Made with campfire warmth.</span>
      </div>
    </footer>
  );
}
